import {
    Amaranth,
    Aspen,
    Dusk,
    EverGreen,
    Gulf,
    KeyWest,
    Laguna,
    LakeBlue,
    Midnight,
    MintGreen,
    OrangeYellow,
    Sand,
    Tetons,
    WarmBlack
} from "./colours"

/**
 * - Add design system colors into palette
 * - Palette primary will be midnight blue, and secondary will be tetons
 * - Refer to Polygon design system https://www.figma.com/file/DsLtETsedvI8spfexMWNLb/⬠-Polygon-Design-System?node-id=1430%3A6993 for colours details
 * - and Figma B2B Mobile app https://www.figma.com/file/MHOICOPv9LZu7OJ79bCWUu/B2B-Mobile-App?node-id=23%3A1061
 */
const palette = {
    primary: {
        main: Midnight[90],
        dark: Midnight[100],
        light: Midnight[50],
        contrastText: "#fff",
    },
    secondary: {
        main: Tetons[100],
    },
    error: {
        main: Amaranth[100],
    },
    success: {
        main: MintGreen[100],
        light: MintGreen[40],
    },
    warning: {
        main: OrangeYellow[100],
    },
    info: {
        main: LakeBlue[100],
    },
    Midnight,
    Gulf,
    Tetons,
    Sand,
    Aspen,
    KeyWest,
    Amaranth,
    MintGreen,
    OrangeYellow,
    LakeBlue,
    Laguna,
    Dusk,
    EverGreen,
    WarmBlack
}

export default palette
